import { useState } from 'react'
import { Globe, X } from 'lucide-react'
import './CountryFilter.css'

export default function CountryFilter({ selectedCountries, onCountriesChange }) {
  const [isOpen, setIsOpen] = useState(false)
  
  const countries = [
    { code: 'US', name: 'Estados Unidos', flag: '🇺🇸' },
    { code: 'CA', name: 'Canadá', flag: '🇨🇦' },
    { code: 'GB', name: 'Reino Unido', flag: '🇬🇧' },
    { code: 'NZ', name: 'Nueva Zelanda', flag: '🇳🇿' },
    { code: 'AU', name: 'Australia', flag: '🇦🇺' },
    { code: 'ES', name: 'España', flag: '🇪🇸' }
  ]

  const toggleCountry = (code) => {
    if (selectedCountries.includes(code)) {
      onCountriesChange(selectedCountries.filter(c => c !== code))
    } else {
      onCountriesChange([...selectedCountries, code])
    }
  }

  const toggleAll = () => {
    if (selectedCountries.length === countries.length) {
      onCountriesChange([])
    } else {
      onCountriesChange(countries.map(c => c.code))
    }
  }

  const getSelectedCountryNames = () => {
    if (selectedCountries.length === 0) return 'Selecciona países'
    if (selectedCountries.length === countries.length) return 'Todos los países'
    return countries
      .filter(c => selectedCountries.includes(c.code))
      .map(c => c.flag)
      .join(' ')
  }

  return (
    <div className="country-filter">
      <button
        className={`country-filter-button${selectedCountries.length > 0 ? ' active' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <Globe className="w-5 h-5" />
        <span>{getSelectedCountryNames()}</span>
      </button>

      {isOpen && (
        <div className="country-filter-dropdown">
          <div className="country-filter-header">
            <h3>Selecciona Países</h3>
            <button 
              className="close-btn"
              onClick={() => setIsOpen(false)}
            >
              <X className="w-5 h-5" />
            </button>
          </div>

          <div className="country-filter-content">
            <button 
              className={`country-select-all ${selectedCountries.length === countries.length ? 'active' : ''}`}
              onClick={toggleAll}
            >
              <input 
                type="checkbox" 
                checked={selectedCountries.length === countries.length}
                readOnly
              />
              <span>Todos los países</span>
            </button>

            <div className="country-divider"></div>

            <div className="country-list">
              {countries.map(country => (
                <button 
                  key={country.code}
                  className={`country-item ${selectedCountries.includes(country.code) ? 'active' : ''}`}
                  onClick={() => toggleCountry(country.code)}
                >
                  <input 
                    type="checkbox" 
                    checked={selectedCountries.includes(country.code)}
                    readOnly
                  />
                  <span className="country-flag">{country.flag}</span>
                  <span className="country-name">{country.name}</span>
                </button>
              ))}
            </div>
          </div>

          <div className="country-filter-footer">
            <span className="country-count">
              {selectedCountries.length} de {countries.length} seleccionados
            </span>
          </div>
        </div>
      )}
    </div>
  )
}
